<template>
    <el-dialog title="已取消产品信息" :visible.sync="inCancelProductDetailDialog" width="800px" :before-close="handleDialogClose"  append-to-body :close-on-click-modal="false" class="custom-form-dialog custom-inventory-dialog">
        <div class="in_product_detail_wrap" v-loading="loading">
            <div class="page_title">
                <span>已入库产品信息</span>
            </div>
            <el-table class="custom_table" :data="tableData" border ref="table" row-key="id" >
                <el-table-column label="产品名称" prop="name" show-overflow-tooltip ></el-table-column>
                <el-table-column label="入库仓库" prop="stocks" show-overflow-tooltip width="196px">
                    <template slot-scope="{row}">
                        <span v-text="row.stocks ? row.stocks.name :''"></span>
                    </template>
                </el-table-column>
                <el-table-column label="入库数量\产品编码" prop="name" align="right" show-overflow-tooltip width="180px">
                    <template slot-scope="{row}">
                        <div class="change_code">
                            <el-popover  placement="bottom"  popper-class="product_code_popper" title=""  width="226"  trigger="click" v-if="row.code_num">
                                <span class="change_code_wrap" slot="reference" >
                                   <span>编码明细</span>
                                </span>
                                <div class="product_code_wrap">
                                    <ul>
                                        <li class="ellipsis" v-for="item in row.details" v-text="item.code"></li>
                                    </ul>
                                    <div class="code_num_wrap">
                                        共：{{row.code_num}}条
                                    </div>
                                </div>
                            </el-popover>
                            <span style="margin-left: 4px" v-text="row.total_num"></span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page_title p_top_24">
                <span>已取消产品信息</span>
            </div>
            <el-table class="custom_table" :data="cancelTableData" border ref="table" row-key="id" >
                <el-table-column label="产品名称" prop="product_name" show-overflow-tooltip ></el-table-column>
                <el-table-column label="取消入库数量" prop="num" align="right" show-overflow-tooltip width="222px"></el-table-column>
            </el-table>

            <div class="in_product_detail_field">
                <div class="in_product_detail_field_name">取消时间</div>
                <div class="in_product_detail_field_value">
                    <div class="in_product_detail_field_text" v-text="formDetail.cancel_at"></div>
                </div>
                <div class="in_product_detail_field_name">取消原因</div>
                <div class="in_product_detail_field_value">
                    <div class="in_product_detail_field_text" v-text="formDetail.reason || '--'"></div>
                </div>

            </div>

        </div>
    </el-dialog>
</template>
<script>
import { pendingInCancelDetail } from "@/api/index.js"
import {pagination} from '@/mixins'
export default {
    name: "in_cancel_product_detail",
    props: {
        inCancelProductDetailDialog: {
            type: Boolean,
            default: false
        },
        inColumnId: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            loading:false,
            tableData:[{}],
            cancelTableData:[],
            formDetail:{}
        }
    },
    mixins: [pagination],
    created() {
        this.getDetails()
    },
    methods: {
        getDetails(){
            this.loading = true
            pendingInCancelDetail({stock_pending_id:this.inColumnId}).then(res => {
                if(res.code == 200){
                    let { cancel_product_list, product_list, pending_info} = res.data
                    this.cancelTableData = cancel_product_list
                    this.tableData = product_list
                    this.formDetail = {
                        cancel_at:pending_info.cancel_at,
                        reason:pending_info.reason,
                    }
                }
                this.loading = false
            })
        },
        handleDialogClose() {
            this.$emit("update:inCancelProductDetailDialog", false)
        },
    }
}
</script>
<style  lang="scss" scoped>
@import "@/styles/inventory_management.scss";
</style>